import React from 'react';
import styles from './AddSiteButton.module.scss';

type AddSiteButtonProps = {
    onClick: () => void;
}

const AddSiteButton:React.FC<AddSiteButtonProps> = ({onClick}) => (
    <div className={styles.Container} onClick={onClick}>
        <div className={styles.PlusIcon}></div>
        <span className={styles.AddSiteText}>ADD SITE</span>
    </div>
)

export default AddSiteButton;